import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useCart } from "./Cart/CartContext";
import LogoutButton from "./Auth/LogoutButton";

function NavBar({ onCartClick }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { cartCount } = useCart();

  const isLoggedIn = !!localStorage.getItem("token");

  const toggleMobileMenu = () => setIsMobileMenuOpen((prev) => !prev);
  const closeMenu = () => setIsMobileMenuOpen(false);

  const scrollToSection = (id) => {
    if (location.pathname !== "/") {
      navigate(`/#${id.slice(1)}`);
      closeMenu();
    } else {
      const section = document.querySelector(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
      closeMenu();
    }
  };

  return (
    <>
      <nav className="bg-sky-900 shadow-md z-50 sticky top-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            <div className="text-2xl font-bold text-sky-100">MagnateForex</div>

            {/* Desktop Menu */}
            <div className="hidden md:flex space-x-4 items-center">
              <Link to="/" className="navButton">Home</Link>
              <Link to="/#about" className="navButton">About</Link>
              <Link to="/#bots" className="navButton">Bots</Link>
              <Link to="/trade-analyzer" className="navButton">Trade Analyzer</Link>
              <Link to="/#testimonials" className="navButton">Testimonials</Link>

              <button onClick={onCartClick} className="relative navButton">
                🛒 Cart
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-2 bg-red-600 text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center">
                    {cartCount}
                  </span>
                )}
              </button>

              {/* Show Logout if logged in */}
              {isLoggedIn && <LogoutButton />}
            </div>

            {/* Mobile Menu Toggle */}
            <div className="md:hidden flex items-center space-x-3">
              <button
                onClick={() => {
                  onCartClick();
                  closeMenu();
                }}
                className="relative text-sky-100 text-2xl"
              >
                🛒
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-bold w-4 h-4 rounded-full flex items-center justify-center">
                    {cartCount}
                  </span>
                )}
              </button>

              <button
                onClick={toggleMobileMenu}
                className="text-sky-100 focus:outline-none font-bold text-3xl"
              >
                ☰
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Overlay */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40"
          onClick={closeMenu}
        ></div>
      )}

      {/* Slide-in Mobile Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-1/2 bg-gray-800 opacity-90 z-40 transform transition-transform duration-300 ${
          isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col p-6 space-y-4 font-bold mt-40 font-merriweather">
          <button
            className="text-sky-100 text-left hover:text-sky-300"
            onClick={() => scrollToSection("#home")}
          >
            Home
          </button>
          <hr />
          <button
            className="text-sky-100 text-left"
            onClick={() => scrollToSection("#about")}
          >
            About
          </button>
          <hr />
          <button
            className="text-sky-100 text-left"
            onClick={() => scrollToSection("#bots")}
          >
            Bots
          </button>
          <hr />
          <button
            className="text-sky-100 text-left"
            onClick={() => {
              navigate("/trade-analyzer");
              closeMenu();
            }}
          >
            Trade Analyzer
          </button>
          <hr />
          <button
            className="text-sky-100 text-left"
            onClick={() => scrollToSection("#testimonials")}
          >
            Testimonials
          </button>

          {/* Mobile Logout */}
          {isLoggedIn && (
            <>
              <hr />
              <div className="text-left">
                <LogoutButton />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default NavBar;
